
import PackTrackDialog from "./pack-track.vue";
import { dialog } from '@/plugins/dialog/index'

/**
 * 物流轨迹弹窗的调用入口。
 *
 * JSX 必须放在 .tsx 文件里，不能写进 .vue 的 <script>：
 * *.vue 的类型来自 src/shims-vue.d.ts，是 DefineComponent<{}, {}, any>（props 是空对象），
 * 而 .vue 的 <script> 块会被 fork-ts-checker 检查，
 * 在那边写 <PackTrackDialog pack={...} /> 会报
 * 「Property 'pack' does not exist on type 'IntrinsicAttributes & {}'」。
 * 项目里其它弹窗（plugins/utils/register 下那些 index.tsx）也都是这个结构。
 *
 * key 必须显式给 'pt'：dialog 按 key 去重，同 key 已存在会直接返回 [{ msg: '已唤起' }] 而不弹
 */
export default function (pack: any, order: any) {
  return dialog({
    title: "物流轨迹",
    props: { width: "640px" },
    content: () => <PackTrackDialog pack={pack} order={order} />,
  }, 'pt')
}
